/**
 * Utility function that creates links to JSP pages
 *
 * @param {string} jspFileName The name of the JSP file
 * @param {string} jspDirectory The directory path of the JSP file. Optional
 * @param {string} queryKey The name of a query param. Optional
 * @param {string} queryValue The value of a query param. Optional
 *
 */

export var generateLink = function generateLink(_ref) {
  var jspFileName = _ref.jspFileName,
    _ref$jspDirectory = _ref.jspDirectory,
    jspDirectory = _ref$jspDirectory === void 0 ? '' : _ref$jspDirectory,
    _ref$queryKey = _ref.queryKey,
    queryKey = _ref$queryKey === void 0 ? '' : _ref$queryKey,
    _ref$queryValue = _ref.queryValue,
    queryValue = _ref$queryValue === void 0 ? '' : _ref$queryValue;
  if (typeof window === 'undefined') {
    return '#';
  }
  var _window = window,
    href = _window.location.href;
  var currentDirectory = href.substring(0, href.lastIndexOf('/'));
  var directory = jspDirectory || currentDirectory;
  var queryString = queryKey && queryValue ? "?" + encodeURIComponent(queryKey) + "=" + encodeURIComponent(queryValue) : '';
  var link = directory + "/" + jspFileName + ".jsp" + queryString;
  return link;
};